<template>
    <div class="page-banner-setting-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">客服專區</div>
            <div class="breadcrumb-item">問題反饋 回覆</div>
        </div>
        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="18" push="5">
                        <Form :label-width="150">
                            <Row>
                                <Col span="14">
									<FormItem>
                                        <div slot="label" class="form-label">
                                            <span>創建時間</span>
                                        </div>
                                        <span>{{form.created_at}}</span>
                                    </FormItem>
									<FormItem>
                                        <div slot="label" class="form-label">
                                            <span>客戶名稱</span>
                                        </div>
                                        <span>{{form.contact}}</span>
                                    </FormItem>
									<FormItem>
                                        <div slot="label" class="form-label">
                                            <span>反饋問題</span>
                                        </div>
                                        <span>{{form.content}}</span>
                                    </FormItem>
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>標題</span>
                                        </div>
                                        <Input v-model="form.title" ref='title' />
                                    </FormItem>
									<FormItem>
									    <div slot="label" class="form-label">
									        <em class="red">* </em>
									        <span>問題解答</span>
									    </div>
									    <Input v-model="form.solution" />
									</FormItem>
                                </Col>
                            </Row>

                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style1" @click="handleCheckForm">提交</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                isSubmiting: false,
                form: {
                    id: '',
					user_id: '',
                    contact: '',
					content: '',
					title: '',
					solution: '',
					created_at: '',
                }
            };
        },
        mounted()
        {
			
            this.pageParam = this.$route.query;
			if(this.pageParam.id != undefined) {
				this.getDetail();
			}
        },
        methods: {
            handleBack()
            {
                this.$router.go(-1);
            },
            getDetail()
            {
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.feedBackEdit + '/' + this.pageParam.id,
                    method: 'get',
                }).then((res) =>{
                    this.isSubmiting = false;
                    if (res.code == 0){
                        let resData = res.data.data;
						for (let i = 0; i < resData.length; i++)
                        {
                        this.form = {
                            id: resData[i].id,
							user_id: resData[i].user_id,
                            contact: resData[i].contact,
							content: resData[i].content,
							created_at: resData[i].created_at,
                        };
						}
                    }
                }).catch((err) =>{
                    this.isSubmiting = false;
                });
            },
            handleCheckForm()
            {
                let form = this.form;
                if (form.title === undefined)
                {
                    this.$Utils.showTipInfo('請輸入標題');
                    return;
                } 
				if (form.solution === undefined)
                {
                    this.$Utils.showTipInfo('請輸入問題解答');
                    return;
                }
				this.handleSubmit();
            },
            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;
				if(this.pageParam.id != undefined) {
					this.$Rq.requestAuth({
					    url: this.$Api.PushFeedBack,
					    method: 'post',
					    data: {
					        type: 1,
					        user_id: form.user_id,
					        contact: form.contact,
					        title: form.title,
							content: form.solution,
							id: form.id
					    }
					}).then((res) => {
					    this.isSubmiting = false;
					    if (res.code == 200) {
					        this.$Utils.showSuccess(res.msg);
							this.$refs.title.focus();
							this.form.title = '';
							this.form.solution = '';
					    } else {
					        this.$Utils.showTipInfo(res.msg);
					    }
					}).catch((err) =>{
					    this.isSubmiting = false;
					});
				}
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "feedbackedit.scss";
</style>